import PostMessageHelper from './PostMessageHelper';
let setScrollEvent = false;
let activeEventListeners = [];
export default function subscribeOnEvents(events) {
    subscribeOnChangeUrl(events);
    handler(events);
}
function handler(events) {
    const hoverEvents = [];
    const clickEvents = [];
    events.forEach((e) => {
        if (isUrlPageCorrect(e.page_url_type, e.page_url)) {
            switch (e.type) {
                case 'onload':
                    postTrigger(e);
                    break;
                case 'click':
                    clickEvents.push(e);
                    break;
                case 'hover':
                    hoverEvents.push(e);
                    break;
                case 'input_change':
                    subscribeOnInputChange(e);
                    break;
                case 'scroll':
                    subscribeOnScroll(e);
                    break;
            }
        }
        else {
            console.log('page is not');
        }
    });
    if (hoverEvents.length) {
        subscribeOnHover(hoverEvents);
    }
    if (clickEvents.length) {
        subscribeOnClick(clickEvents);
    }
}
function subscribeOnInputChange(e) {
    try {
        const elements = window.document.querySelectorAll(e.selector);
        elements.forEach((element) => {
            element.onchange = inputChangeHandler;
            function inputChangeHandler(event) {
                const inputValue = event.target.value;
                console.log(inputValue, 'inputValue');
                postTrigger(e, inputValue);
            }
        });
    }
    catch (error) {
        console.error(error);
    }
}
function subscribeOnClick(events) {
    try {
        const eventName = 'click';
        const listener = function (event) {
            const target = event.target || event.srcElement;
            events.forEach((e) => {
                if (target.matches(e.selector)) {
                    console.log('Отловили событие клик по кнопке ', e.selector);
                    postTrigger(e);
                }
            });
        };
        activeEventListeners.push({
            eventName,
            listener
        });
        document.addEventListener(eventName, listener);
    }
    catch (error) {
        console.error(error);
    }
}
function subscribeOnHover(events) {
    try {
        const eventName = 'mouseover';
        const listener = function (event) {
            const target = event.target || event.srcElement;
            events.forEach((e) => {
                if (target.matches(e.selector)) {
                    console.log('Отловили событие наведения на элемент ', e.selector);
                    postTrigger(e);
                }
            });
        };
        activeEventListeners.push({
            eventName,
            listener
        });
        document.addEventListener(eventName, listener);
    }
    catch (error) {
        console.error(error);
    }
}
function subscribeOnScroll(e) {
    // Check this
    setScrollEvent = false;
    window.onscroll = function () {
        if (setScrollEvent)
            return;
        const scrolled = window.pageYOffset || document.documentElement.scrollTop;
        const innerHeight = document.documentElement.clientHeight;
        if (scrolled > innerHeight * (e.scroll_percent / 100)) {
            console.log('Отловили событие скролла ');
            setScrollEvent = true;
            postTrigger(e);
        }
    };
}
function postTrigger(event, triggerInputValue = '') {
    PostMessageHelper.postMessage({
        name: 'triggerEvent',
        payload: {
            triggerId: event.id,
            triggerInputValue,
            design: event.design
        }
    });
}
function isUrlPageCorrect(type, url) {
    if (type !== 'custom') {
        return true;
    }
    const currentUrl = document.location.href.replace(/\/+$/gm, '').split('?')[0] + '/';
    let pageUrl = url.replace(/\/+$/gm, '');
    let regexString = pageUrl.replace(/\//gm, '\\/');
    regexString = regexString.replace(/\./gm, '\\.');
    regexString = regexString.replace(/\*/gm, '[^ ]*');
    regexString = regexString.replace('https:', 'https?:') + '\\/?$';
    const regex = new RegExp(regexString, 'gm');
    if (regex.exec(currentUrl) === null) {
        return false;
    }
    return true;
}
function subscribeOnChangeUrl(events) {
    // This for handle when we transfer in spa via links or buttons
    const pushState = history.pushState;
    history.pushState = function () {
        pushState.apply(history, arguments);
        handleChangeUrl(events);
    };
    // This for transfer in spa via navigation butttons browser
    window.addEventListener('popstate', function () {
        handleChangeUrl(events);
    });
}
function handleChangeUrl(events) {
    console.log('active listeners: ', activeEventListeners);
    // Remove all events that was before changing url
    activeEventListeners.forEach(({ eventName, listener }) => {
        document.removeEventListener(eventName, listener);
    });
    // Make sure that array is clean before start from scratch at new page
    activeEventListeners = [];
    handler(events);
}
